import { LOCAL_PT_ID_PREFIX } from '../utils';
import { Patient as AptPatient } from '../../api/fetchAppointmentsV3';
import { GENDER_CODE_TO_NAME } from '../../pages/AppointmentUtils';
import { Relation } from '../../api/fetchPatientDirByDocOid';
import { getSalutation } from '../../pages/utils';

function getPtName(selectedPatient: Patient): string {
    const ptName = [selectedPatient.personal.name.f, selectedPatient.personal.name.l]
        .filter(Boolean)
        .join(' ');
    return ptName;
}

export function getPtFullName(selectedPatient: Patient): string {
    const ptFullName = getPtName(selectedPatient);
    return ptFullName;
}

export function getPtFullNameWithSalutation(selectedPatient: Patient): string {
    const ptFullName = getPtName(selectedPatient);
    const salutation = getSalutation(selectedPatient?.formData);
    return `${salutation ? `${salutation} ` : ''}${ptFullName}`;
}

export interface NewPatient extends Patient {
    // required for merge patients only
    id: string;
}

export function isLocalPt(plId?: string): boolean | undefined {
    return plId?.startsWith(LOCAL_PT_ID_PREFIX);
}

export interface FormData {
    label: string;
    type: 'number' | 'string' | 'select';
    key: string;
    value: string | number;
}

export const toLocalPatient = (p: AptPatient, formData: FormData[]): Patient | undefined => {
    if (!p.oid) {
        return;
    }
    return {
        id: p.oid,
        localId: p.oid,
        personal: {
            name: {
                f: p.fn || '',
                l: p.ln || '',
            },
            phone: {
                c: '',
                n: p.mobile,
            },
            gender: GENDER_CODE_TO_NAME[p.gen || ''] || '',
        },
        formData: formData,
    };
};

export interface Patient {
    id?: string;
    localId: string;
    uuid?: string;
    poid?: string;
    payments?: {
        dues: number;
    };
    personal: Personal;
    createdAt?: Date;
    updatedAt?: Date;
    lastVisitedAt?: Date;
    followUpDate?: Date;
    medical?: Medical;
    lastGoingVisit?: string;
    bloodgroup?: string;
    formData?: {
        label: string;
        type: 'number' | 'string' | 'select';
        key: string;
        value: string | number;
    }[];
    archived?: boolean;
    link?: string[];
    abha?: {
        id?: string;
        records?: number;
        cId?: string;
    };
    abhaV2?: {
        id?: string;
        records?: number;
        cId?: string;
        status?: string;
    }[];
    referredBy?: string;
    refer_id?: string;
    refer_doc_id?: string;
    docids?: string[];
    relations?: Relation[];
}

export interface Personal {
    name: Name;
    phone?: Phone;
    age?: Age;
    gender: string;
    onApp?: boolean;
    'health-ids'?: string[];
    fromNdhmDiscovery?: boolean;

    // Only for business patients in get by mobile API
    fromBusiness?: boolean;
}

export interface Age {
    dob?: string;
    value?: string; // age in yrs
    month?: string;
}

export interface Name {
    f: string;
    l?: string;
}

export interface Phone {
    c?: string;
    n?: string;
}

export interface Medical {
    alleriges?: Entity[];
    chronicAilment?: Entity[];
}

export interface Entity {
    name: string;
    id: string;
}
